import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WorkflowHistoryDrawer from '../../components/Workflow/WorkflowHistoryDrawer';

export default function ProjectTracesPage() {
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  return (
    <WorkflowHistoryDrawer
      isOpen={true}
      projectId={projectId}
      projectName={null}
      historyData={null}
      onClose={() => navigate(`/project/${projectId}`)}
    />
  );
}

